document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.section-testimonials');
  const NORMAL_DELAY = 4500;
  const RESUME_DELAY = 1200;
  const FAST_REWIND_TIMEOUT = 120;
  const MAX_REWIND_FRAMES = 60;

  sections.forEach(function (section) {
    if (window.Shopify && Shopify.designMode) return;

    let interval = null;
    let resumeTimeout = null;
    let rewindRaf = null;
    let isRewinding = false;

    function isDisabled(btn) {
      if (!btn) return true;

      return (
        btn.disabled ||
        btn.getAttribute('disabled') !== null ||
        btn.getAttribute('aria-disabled') === 'true' ||
        btn.classList.contains('disabled') ||
        btn.classList.contains('is-disabled') ||
        btn.classList.contains('swiper-button-disabled') ||
        btn.classList.contains('slick-disabled') ||
        btn.classList.contains('flickity-button--disabled')
      );
    }

    function getButton(type) {
      const map = {
        next: [
          '.slider-button--next',
          '.carousel__next',
          '.swiper-button-next',
          '.splide__arrow--next',
          '.slick-next',
          '.flickity-button.next',
          '[data-action="next"]',
          '[aria-label*="Next"]',
          '[aria-label*="next"]',
          '[class*="next"]',
          '[class*="Next"]'
        ],
        prev: [
          '.slider-button--prev',
          '.carousel__prev',
          '.swiper-button-prev',
          '.splide__arrow--prev',
          '.slick-prev',
          '.flickity-button.previous',
          '.flickity-button.prev',
          '[data-action="prev"]',
          '[data-action="previous"]',
          '[aria-label*="Previous"]',
          '[aria-label*="previous"]',
          '[aria-label*="Prev"]',
          '[aria-label*="prev"]',
          '[class*="prev"]',
          '[class*="Prev"]'
        ]
      };

      for (let selector of map[type]) {
        const btn = section.querySelector(selector);
        if (btn) return btn;
      }

      return null;
    }

    function getSliderContainer() {
      const selectors = [
        '[id*="Slider-"]',
        '.slider',
        '.slider--mobile',
        '.multicolumn-list',
        '.multicolumn-grid',
        '.flickity-viewport',
        '.swiper-wrapper',
        '.splide__list'
      ];

      for (let selector of selectors) {
        const el = section.querySelector(selector);
        if (el) return el;
      }

      return null;
    }

    function stopAutoplay() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }

      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }
    }

    function stopRewind() {
      if (rewindRaf) {
        cancelAnimationFrame(rewindRaf);
        rewindRaf = null;
      }
      isRewinding = false;
    }

    function startAutoplay() {
      stopAutoplay();
      if (isRewinding) return;

      interval = setInterval(function () {
        nextOrRestart();
      }, NORMAL_DELAY);
    }

    function resetScrollPosition(container) {
      if (!container) return false;

      try {
        if (typeof container.scrollTo === 'function') {
          container.scrollTo({ left: 0, behavior: 'auto' });
        }
        container.scrollLeft = 0;
        container.dispatchEvent(new Event('scroll', { bubbles: true }));
        return true;
      } catch (e) {
        return false;
      }
    }

    function instantResetAndResume() {
      const container = getSliderContainer();
      const didReset = resetScrollPosition(container);

      if (didReset) {
        isRewinding = false;

        setTimeout(function () {
          startAutoplay();
        }, FAST_REWIND_TIMEOUT);

        return true;
      }

      return false;
    }

    function rewindToStartAndResume() {
      if (isRewinding) return;

      stopAutoplay();
      stopRewind();
      isRewinding = true;

      if (instantResetAndResume()) {
        return;
      }

      let frames = 0;

      function fastStep() {
        const prevBtn = getButton('prev');

        if (!prevBtn || isDisabled(prevBtn) || frames >= MAX_REWIND_FRAMES) {
          stopRewind();

          setTimeout(function () {
            startAutoplay();
          }, FAST_REWIND_TIMEOUT);

          return;
        }

        prevBtn.click();
        frames += 1;
        rewindRaf = requestAnimationFrame(fastStep);
      }

      rewindRaf = requestAnimationFrame(fastStep);
    }

    function nextOrRestart() {
      if (isRewinding) return;

      const nextBtn = getButton('next');

      if (nextBtn && !isDisabled(nextBtn)) {
        nextBtn.click();
        return;
      }

      rewindToStartAndResume();
    }

    function scheduleQuickResume() {
      stopAutoplay();

      resumeTimeout = setTimeout(function () {
        if (isRewinding) return;
        nextOrRestart();
        startAutoplay();
      }, RESUME_DELAY);
    }

    const nextBtn = getButton('next');
    if (!nextBtn) return;

    startAutoplay();

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', scheduleQuickResume);
    section.addEventListener('touchstart', stopAutoplay, { passive: true });
    section.addEventListener('touchend', scheduleQuickResume, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else if (!isRewinding) {
        startAutoplay();
      }
    });
  });
});
